import { render, staticRenderFns } from "./ColoredTag.vue?vue&type=template&id=e5128314&"
import script from "./ColoredTag.vue?vue&type=script&lang=js&"
export * from "./ColoredTag.vue?vue&type=script&lang=js&"
import style0 from "./ColoredTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports